(function () {
  var state = {
    currentOption: 1,
    selectedGiftVariant: null,
    selectedGiftColor: null,
    selectedKitVariant: null,
    selectedKitColor: null,
    selectedKitPrice: 0
  };
  
  var wrap = document.querySelector('.axi-wrap');
  if (!wrap) return;
  
  var cfg = {
    singleVariantId: parseInt(wrap.dataset.singleVariant),
    twoVariantId: parseInt(wrap.dataset.twoVariant || wrap.dataset.singleVariant),
    twoQty: parseInt(wrap.dataset.twoQty || 1),
    kitEnabled: wrap.dataset.kitEnabled === 'true',
    kitVariantId: parseInt(wrap.dataset.kitVariant),
    kitPriceCents: parseInt(wrap.dataset.kitPrice || 0),
    singlePriceCents: parseInt(wrap.dataset.singlePrice || 0),
    bundleVariantId: parseInt(wrap.dataset.bundleVariant),
    singlePct: wrap.dataset.singlePct || 0,
    twoPct: wrap.dataset.twoPct || wrap.dataset.kitDisplayPct || 0,
    bundlePct: wrap.dataset.bundlePct || 0,
    hasGift: wrap.dataset.hasGift === 'true',
    bundleIsVarianted: wrap.dataset.bundleIsVarianted === 'true',
    currentCurrency: wrap.dataset.currentCurrency || 'USD',
    currentCurrencySymbol: wrap.dataset.currentCurrencySymbol || '$',
    currentCountry: wrap.dataset.currentCountry || '',
    currentLocale: wrap.dataset.currentLocale || document.documentElement.lang || 'en'
  };
  
  var initialActiveOption = wrap.querySelector('.axi-option.active');
  if (initialActiveOption && initialActiveOption.id === 'axi-opt-3') {
    state.currentOption = 3;
  } else if (initialActiveOption && initialActiveOption.id === 'axi-opt-2') {
    state.currentOption = 2;
  } else {
    state.currentOption = 1;
  }
  
  var firstColorBtn = wrap.querySelector('.axi-color-btn[data-id]');
  if (firstColorBtn) {
    state.selectedGiftVariant = parseInt(firstColorBtn.dataset.id);
    state.selectedGiftColor = firstColorBtn.dataset.name;
  }
  
  var firstKitBtn = wrap.querySelector('.axi-kit-variant-btn[data-id]');
  if (firstKitBtn) {
    state.selectedKitVariant = parseInt(firstKitBtn.dataset.id);
    state.selectedKitColor = firstKitBtn.dataset.name;
    state.selectedKitPrice = parseInt(firstKitBtn.dataset.price || cfg.kitPriceCents || 0);
    cfg.kitVariantId = state.selectedKitVariant;
  } else if (cfg.kitVariantId) {
    state.selectedKitVariant = cfg.kitVariantId;
    state.selectedKitPrice = cfg.kitPriceCents || 0;
  }
  
  function show(el, display) {
    if (el) el.style.display = display;
  }
  function toggleActive(selector, active) {
    var el = wrap.querySelector(selector);
    if (el) el.classList.toggle('active', active);
  }
  function formatMoney(cents) {
    var value = parseInt(cents || 0, 10) / 100;
    var numString = value.toFixed(2);
    if (cfg.currentCurrency === 'EUR' || cfg.currentLocale.startsWith('de') || cfg.currentLocale.startsWith('fr') || cfg.currentLocale.startsWith('nl') || cfg.currentLocale.startsWith('es') || cfg.currentLocale.startsWith('it')) {
      numString = numString.replace('.', ',');
    }
    return (cfg.currentCurrencySymbol || '') + numString;
  }
  function setMoneyText(selector, cents) {
    var el = wrap.querySelector(selector);
    if (!el) return;
    el.textContent = formatMoney(cents);
  }
  function getActiveKitButton() {
    return wrap.querySelector('.axi-kit-variant-btn.active') || wrap.querySelector('.axi-kit-variant-btn[data-id]');
  }
  function updateKitPricing() {
    if (!cfg.kitEnabled) return;
    var btn = getActiveKitButton();
    var compareCents = btn ? parseInt(btn.dataset.compare || 0, 10) : parseInt(wrap.dataset.kitCompare || 0, 10);
    var finalCents = btn ? parseInt(btn.dataset.final || 0, 10) : parseInt(wrap.dataset.kitFinal || 0, 10);
    var savedCents = btn ? parseInt(btn.dataset.saved || 0, 10) : parseInt(wrap.dataset.kitSaved || 0, 10);
    setMoneyText('#axi-pricing-two .axi-price-main .money', finalCents);
    setMoneyText('#axi-pricing-two .axi-price-sub s .money', compareCents);
    setMoneyText('#axi-pricing-two .axi-saved-pill .money', savedCents);
    setMoneyText('#axi-kit-option-price', finalCents);
    setMoneyText('#axi-kit-option-saved', savedCents);
    setMoneyText('#axi-kit-alert-saved', savedCents);
    var effectivePct = btn && btn.dataset.effectivePct ? btn.dataset.effectivePct : cfg.twoPct;
    if (state.currentOption === 2 && effectivePct) {
      var ringPct = wrap.querySelector('#axi-ring-pct');
      if (ringPct) ringPct.textContent = effectivePct + '%';
    }
  }
  function shopifyRoute(path) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    if (path.charAt(0) === '/') path = path.slice(1);
    return root + path;
  }
  function getActiveOptionPriceText() {
    return formatMoney(cfg.singlePriceCents);
  }
  function getActiveOptionTitleText() {
    var opt1Title = wrap.querySelector('#axi-opt-1 .axi-option-title');
    if (opt1Title && opt1Title.textContent.trim()) {
      return opt1Title.textContent.trim();
    }
    var productJson = document.getElementById('ProductJson-product-template');
    if (productJson) {
      try { return JSON.parse(productJson.textContent).title; } catch(e) {}
    }
    var ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) return ogTitle.getAttribute('content');
    return document.title.split('–')[0].trim();
  }
  function syncStickyAtc() {
    var priceText = cfg.singlePriceCents ? getActiveOptionPriceText() : null;
    var titleText = getActiveOptionTitleText();
    if (!titleText) return;
    var stickyRoots = document.querySelectorAll('.sticky-add-to-cart, sticky-add-to-cart, .sticky-add-to-cart-wrapper, .product-sticky-atc, .sticky-atc');
    stickyRoots.forEach(function (root) {
      if (priceText) {
        root.querySelectorAll('.money, .price-item, .price__regular, .price__sale, .sticky-add-to-cart__price, .sticky-add-to-cart__button .money, [data-price], .price').forEach(function (priceNode) {
          if (priceNode.closest('s') || priceNode.closest('.price__compare') || priceNode.matches('s *') || priceNode.classList.contains('badge')) return;
          priceNode.textContent = priceText;
        });
      }
      root.querySelectorAll('.price__compare, .compare-at-price, [data-compare-price]').forEach(function (compareNode) {
        if (cfg.singlePriceCents < parseInt(wrap.dataset.singleCompare || 0)) {
          compareNode.textContent = formatMoney(parseInt(wrap.dataset.singleCompare || 0));
          compareNode.style.display = '';
        } else {
          compareNode.style.display = 'none';
        }
      });
      root.querySelectorAll('.axi-saved-pill, .badge--sale, .price__badge, .save-badge, [class*="save"]').forEach(function (badgeNode) {
        if (cfg.singlePriceCents < parseInt(wrap.dataset.singleCompare || 0)) {
          badgeNode.style.display = '';
        } else {
          badgeNode.style.display = 'none';
        }
      });
      if (titleText) {
        root.querySelectorAll('.sticky-add-to-cart__title').forEach(function (titleNode) {
          var words = titleText.trim().split(' ');
          var last = words.pop();
          var first = words.join(' ');
          var newHtml = '<span class="sticky-title-main">' + first + '</span> <span class="sticky-title-highlight">' + last + '</span>';
          if (titleNode.innerHTML !== newHtml) titleNode.innerHTML = newHtml;
        });
        root.querySelectorAll('.sticky-add-to-cart__product-title, .product-title').forEach(function (titleNode) {
          if (titleNode.textContent.trim() !== titleText) titleNode.textContent = titleText;
        });
        if (root.tagName === 'STICKY-ADD-TO-CART' || root.hasAttribute('data-default-variant-title')) {
          root.setAttribute('data-default-variant-title', titleText);
        }
        root.querySelectorAll('[data-default-variant-title]').forEach(function(el) {
          el.setAttribute('data-default-variant-title', titleText);
        });
      }
    });
  }

  window.axiSelectOption = function (opt) {
    state.currentOption = opt;
    toggleActive('#axi-opt-1', opt === 1);
    toggleActive('#axi-opt-2', opt === 2);
    toggleActive('#axi-opt-3', opt === 3);
    
    var viewBtn = wrap.querySelector('.axi-view-bundle'), 
        pricingSingle = wrap.querySelector('#axi-pricing-single'), pricingTwo = wrap.querySelector('#axi-pricing-two'), pricingBundle = wrap.querySelector('#axi-pricing-bundle'),
        alertSingle = wrap.querySelector('#axi-alert-single'), alertTwo = wrap.querySelector('#axi-alert-two'), alertBundle = wrap.querySelector('#axi-alert-bundle'),
        eyebrow = wrap.querySelector('#axi-eyebrow'), ringPct = wrap.querySelector('#axi-ring-pct');
        
    var isBuyTwo = opt === 2, isBundle = opt === 3;
    
    if (viewBtn) viewBtn.classList.toggle('visible', isBundle);
    
    show(pricingSingle, opt === 1 ? 'block' : 'none');
    show(pricingTwo, isBuyTwo ? 'block' : 'none');
    show(pricingBundle, isBundle ? 'block' : 'none');
    show(alertSingle, opt === 1 ? 'flex' : 'none');
    show(alertTwo, isBuyTwo ? 'flex' : 'none');
    show(alertBundle, isBundle ? 'flex' : 'none');
    
    if (opt === 1) {
      if (eyebrow) eyebrow.textContent = 'Limited Offer';
      if (ringPct) ringPct.textContent = cfg.singlePct + '%';
    } else if (isBuyTwo) {
      if (eyebrow) eyebrow.textContent = 'Grooming Kit';
      if (ringPct) ringPct.textContent = cfg.twoPct + '%';
      updateKitPricing();
    } else if (isBundle) {
      if (eyebrow) eyebrow.textContent = 'Limited Bundle Offer';
      if (ringPct) ringPct.textContent = cfg.bundlePct + '%';
    }
    updateKitPricing();
    syncStickyAtc();
  };
  
  window.axiPickKitVariant = function (btn, event) {
    if (event) event.stopPropagation();
    if (!btn || btn.disabled) return;
    wrap.querySelectorAll('.axi-kit-variant-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    
    state.selectedKitVariant = parseInt(btn.dataset.id);
    state.selectedKitColor = btn.dataset.name;
    state.selectedKitPrice = parseInt(btn.dataset.price || 0);
    cfg.kitVariantId = state.selectedKitVariant;
    var image = wrap.querySelector('#axi-kit-image');
    if (image && btn.dataset.image) {
      image.src = btn.dataset.image;
      image.alt = 'LUCIO® Manicure Kit — ' + state.selectedKitColor;
    }
    updateKitPricing();
    syncStickyAtc();
  };
  
  window.axiPickColor = function (btn) {
    wrap.querySelectorAll('.axi-color-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    state.selectedGiftVariant = parseInt(btn.dataset.id);
    state.selectedGiftColor = btn.dataset.name;
    if (cfg.bundleIsVarianted) cfg.bundleVariantId = state.selectedGiftVariant;
    var giftImage = wrap.querySelector('#axi-gift-image');
    if (giftImage && btn.dataset.image) {
      giftImage.src = btn.dataset.image;
      giftImage.alt = 'LUCIO® Manicure Kit — ' + state.selectedGiftColor;
    }
    syncStickyAtc();
  };
  
  window.axiQty = function (d) {
    var el = wrap.querySelector('#axi-qty');
    if (!el) return;
    el.textContent = Math.max(1, parseInt(el.textContent) + d);
    syncStickyAtc();
  };

  /* --- NEW ADD TO CART FUNCTION (AJAX Cart API) --- */
  window.axiAddToCart = function (event) {
    if (event) { 
      event.preventDefault(); 
      event.stopPropagation(); 
    }

    var btn = wrap.querySelector('#axi-atc-btn');
    var qtyEl = wrap.querySelector('#axi-qty');
    if (!btn || !qtyEl) return;

    var selectedQty = Math.max(1, parseInt(qtyEl.textContent) || 1);

    // 1. Validate choices before doing anything
    if (state.currentOption === 3 && cfg.hasGift && !state.selectedGiftVariant) {
      btn.textContent = 'Choose LUCIO® colour';
      setTimeout(function(){ btn.textContent = 'Add to Cart'; }, 2500);
      return;
    }
    if (state.currentOption === 2 && !state.selectedKitVariant) {
      btn.textContent = 'Choose LUCIO® variant';
      setTimeout(function(){ btn.textContent = 'Add to Cart'; }, 2500);
      return;
    }

    // 2. Build the items array for whichever option is selected
    var items = [];
    if (state.currentOption === 3) {
      items.push({ id: cfg.bundleVariantId, quantity: selectedQty });
      if (cfg.hasGift) {
        items.push({ id: state.selectedGiftVariant, quantity: selectedQty });
      }
    } else if (state.currentOption === 2) {
      items.push({ id: cfg.twoVariantId, quantity: selectedQty });
      items.push({ id: state.selectedKitVariant, quantity: selectedQty });
    } else {
      items.push({ id: cfg.singleVariantId, quantity: selectedQty });
    }

    // 3. Call Shopify's Cart AJAX API directly
    btn.textContent = 'Adding...';
    btn.classList.add('loading');

    fetch(shopifyRoute('cart/add.js'), {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  body: JSON.stringify({ items: items })
})
.then(function (r) {
  if (!r.ok) return r.json().then(function (e) { throw e; });
  return r.json();
})
.then(function (cart) {
  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      data: {
        itemCount: cart.item_count,
        source: 'axi-atc'
      }
    }
  }));
  return cart;
})
.then(function () {
  btn.classList.remove('loading');
  btn.textContent = 'Added to Cart!';
  setTimeout(function () { btn.textContent = 'Add to Cart'; }, 2500);
})
.catch(function (err) {
  console.error('AXI add to cart failed:', err);
  btn.classList.remove('loading');
  btn.textContent = (err && err.description) ? err.description : 'Error adding item';
  setTimeout(function () { btn.textContent = 'Add to Cart'; }, 2500);
});
};
  
  window.axiJumpTo = function (product) {
    if (typeof axiRenderEditorial === 'function') axiRenderEditorial(product || 'zavic');
    var section = document.getElementById('axi-design-section');
    if (section) window.scrollTo({ top: section.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateKitPricing);
  } else {
    updateKitPricing();
  }
})();